<template>
  <div class="text-center">
    <v-progress-circular
      :size="60"
      color="primary"
      indeterminate
    />
  </div>
</template>

<script>
export default {
  name: 'AppLoader',
};
</script>
